import { LcAddress } from "@/domains/core"
import { DomainEvent } from "@/domains/events"

export class ManagerModeChangedEvent extends DomainEvent {
  static readonly TYPE = "manager.mode-changed"
  readonly type = ManagerModeChangedEvent.TYPE
  constructor(
    public readonly isManagerMode: boolean,
    public readonly managerAddress: LcAddress | null,
  ) {
    super()
  }
}
